import PropTypes from 'prop-types';
import React from 'react';
import {Redirect, Route} from 'react-router-dom';
import {hasRoleLevel, roleLevels} from '@account/utils';
import {useAuth} from '@apps-common/auth-react';

const SecureRoute = ({roles, children, ...props}) => {
  const auth = useAuth();

  if (hasRoleLevel(auth, roles)) {
    return <Route {...props}>{children}</Route>;
  }

  return <Redirect to="/" />;
};

SecureRoute.propTypes = {
  children: PropTypes.node,
  computedMatch: PropTypes.object,
  roles: PropTypes.arrayOf(PropTypes.oneOf(Object.values(roleLevels))),
};

export default SecureRoute;
